// src/lib/firebase.js
// Replace the firebaseConfig values with your own from Firebase Console
// Project Settings → Your Apps → Web App → Config

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import {
  getFirestore, initializeFirestore,
  persistentLocalCache, persistentMultipleTabManager,
} from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAtoCTBhC5fsYZb_s9QkqGCYRJpJMfd4uY",
    authDomain: "agt-pos-ee984.firebaseapp.com",
    projectId: "agt-pos-ee984",
    storageBucket: "agt-pos-ee984.firebasestorage.app",
    messagingSenderId: "599121432069",
    appId: "1:599121432069:web:193e6005872ee2766c966c"
  };

const app  = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/**
 * Firestore with an on-disk cache, so the installed app still opens and shows
 * today's orders when the shop's internet drops. Writes made offline are
 * queued and sent when the connection returns.
 *
 * `persistentMultipleTabManager` matters here: the counter and the back bench
 * may both have the app open, and without it the second tab fails to acquire
 * the cache lock.
 *
 * Falls back to the in-memory cache if IndexedDB is unavailable (private
 * browsing, locked-down profiles) — the app works, it just isn't offline-capable.
 */
function makeDb() {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
    });
  } catch (err) {
    console.warn('[firebase] offline cache unavailable, using memory only:', err?.message);
    return getFirestore(app);
  }
}

export const db = makeDb();
export default app;
